import { t } from 'i18next'

import { TerminateSuggestionAction } from './useTerminateSuggestions'

export const useTerminatePendingSuggestion = () => ({
  terminatePendingSuggestion: {
    id: TerminateSuggestionAction.PENDING,
    label: t('terminateContract:terminateSuggestions.pending'),
    disabled: true,
  },
})
